import Vue from 'vue';
import _ from 'lodash';
import {
    GET_STAFF_LIST_REQUEST,
    GET_STAFF_LIST_SUCCESS,
    GET_STAFF_LIST_FAILURE,
    UPDATE_STAFF_LIST_PARAMS,
    RESOLVE_STAFF_LIST_PARAMS,
    RESET_STAFF_LIST_DATA
} from '../mutationTypes';

const state = {
    loading: false,
    page: 1,
    pageSize: 20,
    pageCount: 0,
    count: 0,
    searchKey: '1',
    searchVal: '',
    status: '0',
    list: [],
    params: {},
};

const mutations = {
    [GET_STAFF_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_STAFF_LIST_SUCCESS](state, res) {
        state.loading = false;

        const {
            page_count: pageCount,
            data,
            count,
        } = res;

        state.list = data;
        state.pageCount = pageCount;
        state.count = count;
    },
    [GET_STAFF_LIST_FAILURE](state) {
        state.loading = false;
        state.list = [];
    },
    [UPDATE_STAFF_LIST_PARAMS](state, params) {
        const { page, searchKey, searchVal, status, type, index } = params;

        if (page) {
            state.page = page;
            state.params.page = page;
        }

        if (searchVal || searchVal === '') {
            state.searchVal = searchVal;
        }

        if (type === 'del' && index <= state.list.length) {
            state.list.splice(index, 1);
        }

        // 下面两个选项不能出现空值
        if (searchKey) state.searchKey = searchKey;
        if (status) state.status = status;
    },
    [RESOLVE_STAFF_LIST_PARAMS](state, params) {
        state.params = params;
    },
    [RESET_STAFF_LIST_DATA](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            page: 1,
            pageSize: 20,
            pageCount: 0,
            searchKey: '1',
            searchVal: '',
            status: '0',
            list: [],
            params: {},
        }));
    },
};

export const actions = {
    async getStaffList({ commit }) {
        commit(GET_STAFF_LIST_REQUEST);

        const reqParams = {
            page: state.params.page,
            pagesize: state.params.pageSize,
            status: state.params.status,
            search_key: state.params.searchKey,
            search_val: state.params.searchVal,
        }; // 修改字段格式

        const res = await Vue.$ajax.get('staffList', reqParams);

        if (!res.errorType) {
            commit(GET_STAFF_LIST_SUCCESS, res);
        } else {
            commit(GET_STAFF_LIST_FAILURE);
        }
    },
    resolveStaffListParams({ commit }) {
        const params = _.pick(state, ['page', 'pageSize',
            'searchKey', 'searchVal', 'status']);


        commit(RESOLVE_STAFF_LIST_PARAMS, params);
    },
    resetStaffList({commit}) {
        commit(RESET_STAFF_LIST_DATA);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/staffList.js